import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Smart index redirect for /profile.
 *
 * Stripe checkout returns the user to /profile?subscription_success=true. The
 * activation polling + modal live on the Plan tab now, so when that param is
 * present we forward to the Plan tab WITH the query string preserved — otherwise
 * the default /profile -> /profile/account redirect would drop the param and the
 * post-payment confirmation would silently never fire. No param -> Account tab.
 */
const ProfileIndexRedirect: React.FC = () => {
  const { search } = useLocation();
  const returningFromStripe =
    new URLSearchParams(search).get('subscription_success') === 'true';
  return <Navigate to={returningFromStripe ? `plan${search}` : 'account'} replace />;
};

export default ProfileIndexRedirect;
